export default __webpack_public_path__ + "static/media/user-active.dc297ad6.svg";